import LoginForm from '../../components/auth/LoginForm'
import SimpleLoginForm from '../../components/auth/SimpleLoginForm'
import DirectLoginForm from '../../components/auth/DirectLoginForm'

const AdminLogin = () => {
  // Utiliser le formulaire direct pour éviter tous les problèmes
  return <DirectLoginForm />
}

export default AdminLogin
